import React, { useState } from 'react';
import { setUserId } from '../utils/userId';

interface UserIdInputProps {
  onUserIdSet: () => void;
}

const UserIdInput: React.FC<UserIdInputProps> = ({ onUserIdSet }) => {
  const [userId, setUserIdValue] = useState<string>('');
  const [error, setError] = useState<string>('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const trimmedUserId = userId.trim();
    
    if (!trimmedUserId) {
      setError('사용자 ID를 입력해주세요.');
      return;
    }

    if (trimmedUserId.length < 2) {
      setError('사용자 ID는 최소 2자 이상이어야 합니다.');
      return;
    }

    if (trimmedUserId.length > 20) {
      setError('사용자 ID는 최대 20자까지 입력 가능합니다.');
      return;
    }

    // 알파벳으로 시작하고 알파벳/숫자만 허용
    const alphanumericPattern = /^[a-zA-Z][a-zA-Z0-9]*$/;
    if (!alphanumericPattern.test(trimmedUserId)) {
      if (!/^[a-zA-Z]/.test(trimmedUserId)) {
        setError('사용자 ID는 알파벳으로 시작해야 합니다.');
      } else {
        setError('사용자 ID는 알파벳과 숫자만 사용할 수 있습니다.');
      }
      return;
    }

    setError('');
    setUserId(trimmedUserId);
    onUserIdSet();
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px',
        width: '100%'
      }}>
        <h2 style={{
          margin: '0 0 10px 0',
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#333',
          textAlign: 'center'
        }}>
          사용자 ID 입력
        </h2>
        <p style={{
          margin: '0 0 30px 0',
          fontSize: '14px',
          color: '#666',
          textAlign: 'center'
        }}>
          가상의 USER ID 를 입력해 주세요.<br />
          다른곳 에서도 동일한 USER ID 를 사용하면 읽기 기록이 연동 됩니다.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div style={{ 
            display: 'flex', 
            gap: '8px',
            marginBottom: error ? '8px' : '0'
          }}>
            <input
              type="text"
              value={userId}
              onChange={(e) => {
                const value = e.target.value;
                // 알파벳과 숫자만 허용
                const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '');
                
                if (filteredValue.length <= 20) {
                  setUserIdValue(filteredValue);
                  setError('');
                }
              }}
              placeholder="사용자 ID를 입력하세요 (알파벳으로 시작)"
              maxLength={20}
              style={{
                flex: 1,
                padding: '8px 12px',
                fontSize: '14px',
                border: error ? '2px solid #dc3545' : '2px solid #ddd',
                borderRadius: '6px',
                boxSizing: 'border-box',
                outline: 'none',
                transition: 'border-color 0.2s'
              }}
              autoFocus
            />
            <button
              type="submit"
              style={{
                padding: '8px 20px',
                fontSize: '14px',
                fontWeight: 'bold',
                color: 'white',
                backgroundColor: '#007bff',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#0056b3';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#007bff';
              }}
            >
              확인
            </button>
          </div>
          {error && (
            <p style={{
              margin: '8px 0 0 0',
              fontSize: '12px',
              color: '#dc3545'
            }}>
              {error}
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default UserIdInput;

